module.exports = __webpack_public_path__ + "static/media/compassion.c9584dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/values/compassion.jpg
// module id = 5747
// module chunks = 6